/***
 * 进入路由前的操作
 */
export const route = {
  redirect: '/home/main'
};
export const tasks = [
  {
    name: '获取彩种列表',
    handle() {
      if (window.vm_app) {
        return window.vm_app.$store.dispatch('home/fetchHeadTabs');
      }
      return Promise.resolve();
    }
  }
];



// WEBPACK FOOTER //
// ./src/pages/home/index.js